import { LevelsListView } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._components.levels-list-view";

/** Levels → All route: every level, unfiltered. */
export function BrowseLevelsAllPage() {
  return <LevelsListView completionFilter="all" />;
}
